/**
 * スタッフ出勤判定ユーティリティ
 *
 * priority の値で本日出勤/オフを判定する:
 *   - 1〜999: オフ
 *   - 1000〜1999: 本日出勤（= 1000 + オフ時の値）
 *
 * 他のコンポーネントからも利用可能な共通ユーティリティ。
 */

export const ON_DUTY_THRESHOLD = 1000;

/** 出勤中かどうかを判定 */
export const isOnDuty = (priority: number | null | undefined): boolean =>
  typeof priority === 'number' && priority >= ON_DUTY_THRESHOLD;

/** ベース優先度（オフ時の値 1〜999）を取得 */
export const basePriority = (priority: number): number =>
  ((priority % ON_DUTY_THRESHOLD) || 0);

/** 出勤状態にする（1000を加算） */
export const toOnDuty = (priority: number): number =>
  basePriority(priority) + ON_DUTY_THRESHOLD;

/** オフ状態にする（1000未満に正規化） */
export const toOffDuty = (priority: number): number =>
  basePriority(priority);

/**
 * 常に本日出勤扱いする固定スタッフ判定
 * - 共用アカウント: staff_login_id === 'staff' or staff_name === 'staff'/'スタッフ'
 * - スポット: staff_name === 'タイミー'
 *
 * これらは「本日勤務」管理モーダルにも、対応者選択モーダルにも表示しない（固定）。
 */
export const isFixedStaff = (s: any): boolean => {
  const name = String(s?.staff_name || '').trim();
  const loginId = String(s?.staff_login_id || '').trim();
  return loginId === 'staff' || name === 'staff' || name === 'スタッフ' || name === 'タイミー';
};
